<script lang="ts">
	import Carousel from "@components/common/Carousel.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Icon from "@components/common/Icon.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { EmblaCarouselType } from "embla-carousel";
	import arrowIcon from "@core/assets/icons/arrow.svg?raw";
	import WholesalePartnerCard from "./WholesalePartnerCard.svelte";
	import type { WholesalePartner } from "./WholesalePartnerCardProps.js";
	import translations from "./WholesalePartners.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	let canNext = $state(false);
	let canPrev = $state(false);

	let api = $state<EmblaCarouselType>();

	const partnes: WholesalePartner[] = [
		{
			author: translate("reviewMatildaAuthor"),
			cite: translate("reviewMatildaCite"),
		},
		{
			author: translate("reviewKiosekAuthor"),
			cite: translate("reviewKiosekCite"),
		},
		{
			author: translate("reviewKofeBrakAuthor"),
			cite: translate("reviewKofeBrakCite"),
		},
		{
			author: translate("reviewShothouseAuthor"),
			cite: translate("reviewShothouseCite"),
		},
		{
			author: translate("reviewNebeskaAuthor"),
			cite: translate("reviewNebeskaCite"),
		},
	];
</script>

<div class="flex justify-between mb-9 md:mb-15 items-center">
	<div class="text-fcrdarkgray font-medium font-antipol text-8/tighter">
		<Heading level={2} text={translate("ourPartnersTitle")} />
	</div>
	<div class="hidden lg:flex gap-2 text-fcrdarkgray">
		<button
			type="button"
			class={[
				"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
				"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
				"[&:not(:disabled):hover]:border-fcrdarkgray",
			]}
			onclick={(): void => {
				api?.scrollPrev();
			}}
			disabled={!canPrev}
		>
			<Icon icon={arrowIcon} class="size-4.5 rotate-180" />
		</button>
		<button
			type="button"
			class={[
				"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
				"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
				"[&:not(:disabled):hover]:border-fcrdarkgray",
			]}
			onclick={(): void => {
				api?.scrollNext();
			}}
			disabled={!canNext}
		>
			<Icon icon={arrowIcon} class="size-4.5 " />
		</button>
	</div>
</div>

<Carousel
	bind:canNext
	bind:canPrev
	bind:api
	options={{ dragFree: true }}
	items={partnes}
	class="full-width"
	itemsContainerClass="gap-8"
	alignWithGridContainer
>
	{#snippet item(partner)}
		<WholesalePartnerCard {partner} />
	{/snippet}
</Carousel>
